<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />
    <b-card>
      <WarehouseSoComponents />
    </b-card>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import WarehouseSoComponents from '@/components/salesorder/WarehouseSoComponents.vue'

export default {
  name: 'WarehouseSalesOrder',

  components: {
    WarehouseSoComponents
  },

  middleware: ['auth', 'warehouse'],

  metaInfo () {
    return {
      title: 'Sales Order'
    }
  },

  mounted () {
    core.index()
  }
}
</script>
